/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfficeDto } from '../../models/office-dto';

export interface OfficeControllerFindOne$Params {
  id: number;
}

export function officeControllerFindOne(http: HttpClient, rootUrl: string, params: OfficeControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<OfficeDto>> {
  const rb = new RequestBuilder(rootUrl, officeControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfficeDto>;
    })
  );
}

officeControllerFindOne.PATH = '/api/office/{id}';
